import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Constants } from '@base/src/app/models/constants';
import { QRButton } from '@base/src/app/models/qr-button.model';
import { QRIcon } from '@base/src/app/models/qr-icon.model';
import { UtilsService } from '@base/src/app/services/utils.service';
import {
  CatchmentDetail,
  ReservationDetail,
} from '../../../models/statList-item';
import { Router } from '@angular/router';
import { NavigationOriginTypes } from '../../../../../property-manager/models/navigation-origin-types.model';
import { environment } from '@base/environments/environment';

@Component({
  selector: 'app-dialog-preview',
  templateUrl: './dialog-preview-reservation.component.html',
  styleUrls: ['./dialog-preview-reservation.component.scss'],
})
export class DialogPreviewComponent implements OnInit {
  @Input() reservation?: ReservationDetail | null;
  @Input() catchment?: CatchmentDetail | null;
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

  NODE = environment.node;
  NODE_AR = Constants.TENANT_ID_AR;
  NODE_EC = Constants.TENANT_ID_EC;
  NODE_DO = Constants.TENANT_ID_DO;
  NODE_PY = Constants.TENANT_ID_PY;
  NODE_GLOBAL = Constants.TENANT_ID_GLOBAL;

  title: string = '';
  isReservation: boolean = true;

  readonly ICON_CHECK: string = Constants.ICONS.CHECK;
  readonly ICON_COLOR_WHITE: string = QRIcon.COLOR_WHITE;

  buttonGoBack: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Volver',
  };

  buttonGenerateClose: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.CALENDAR_CHECK,
    iconOnly: false,
    viewValue: 'Generar cierre',
  };

  buttonGenerateNewReservation: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.CALENDAR_CHECK,
    iconOnly: false,
    viewValue: 'Generar reserva',
  };

  constructor(
    public readonly utils: UtilsService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    const IS_RESERVATION = this.reservation?.statisticsType === 'Reserva';
    this.isReservation = IS_RESERVATION;
    this.title = this.isReservation ? 'reserva' : 'captación';
  }

  closeDialog(): void {
    this.close.emit(true);
  }

  generateClose(): void {
    const QUERY_PARAMS = {
      queryParams: { origin: NavigationOriginTypes.LIST },
    };

    if (
      this.reservation &&
      this.NODE !== this.NODE_PY &&
      this.NODE !== this.NODE_EC
    ) {
      this.router.navigate(
        ['/renditions/reserve/' + this.reservation.id],
        QUERY_PARAMS,
      );
    } else if (this.reservation && (this.NODE === this.NODE_PY || this.NODE === this.NODE_EC)) {
      // Rendiciones NO migradas en Paraguay y Ecuador - Redirect al viejo front 
      window.location.href =
        environment.oldFrontUrl + '/rendicion/add/' + this.reservation?.id;
    }

    if (this.catchment) {
      this.router.navigate(
        ['/nueva-reserva/' + this.catchment.id],
        QUERY_PARAMS,
      );
    }
  }

  get currencySymbol(): string {
    const CURRENCY = this.reservation?.currency ?? this.catchment?.currency;

    return CURRENCY === 'USD' ? 'U$S' : '$';
  }
}
